import { useEffect, useState } from "react";
import { X } from "lucide-react";

const KEY = "tcsw_cookie_consent_v1";

/**
 * Minimal cookie/analytics consent banner — PIPEDA-friendly.
 * Shows once, dismissed for 12 months. First-party analytics only (no advertising cookies).
 */
export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setTimeout(() => setShow(true), 1200);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-6 left-6 z-40 max-w-md bg-ink-900 border border-white/10 shadow-2xl p-5 rounded-sm">
      <div className="flex items-start gap-4">
        <div className="flex-1">
          <h4 className="font-display text-base text-white">We use cookies</h4>
          <p className="text-white/55 text-[12px] mt-2 leading-relaxed">
            We use first-party cookies for analytics (Google Analytics &amp; Microsoft Clarity) to understand how
            our site is used and improve it. No advertising, no tracking sold to third parties.
          </p>
        </div>
        <button onClick={accept} aria-label="Close" data-testid="cookie-close" className="text-white/40 hover:text-white">
          <X size={16}/>
        </button>
      </div>
      <button
        onClick={accept}
        data-testid="cookie-accept"
        className="btn-gold mt-4 w-full justify-center !py-2.5 !text-[11px]"
      >
        Got it
      </button>
    </div>
  );
}
